import './config/i18n';
import {createRoot} from 'react-dom/client';
import './index.css';
import './typography.css';
import './assets/fonts.css';
import {ClientProvider} from './core/context/ClientContext';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {throw new Error('Failed to find the root element');}

const root = createRoot(rootElement);
root.render(
  <ClientProvider>
    <App />
  </ClientProvider>
);
